// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:root {
    /* TODO: we should probably use variables now, rather than overriding styles (see mapView.less) */
    /* --ol-foreground-color: #f0f0f0; */
    /* --ol-subtle-foreground-color: #e0e0e0; */
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
